import { PointInterface } from './interfaces/PointInterface'

export class Point implements PointInterface {
    userId: number;
    rank: number;
    points: number;
    rankShift: number;

    constructor(data: PointInterface) {
        Object.assign(this, data);
    }
}